export default __webpack_public_path__ + "static/continuous-integration-6a3e8c20194bc95a54705ced4fb5011d.png";